import { defineAsyncComponent } from 'vue'
import { tabOutlineFiles } from 'quasar-extras-svg-icons/tabler-icons-v3'
import type { FeatureConfig } from 'models/FeatureConfig'
import { hasInvalidDigitalTwins } from 'utils/type-checks'

const featureConfig: FeatureConfig = {
  drawer: {
    drawerComponent: defineAsyncComponent(() => import('./FilesFeatureDrawerMain.vue')),
    icon: tabOutlineFiles,
    label: 'Files',
    hide: hasInvalidDigitalTwins
  },
  contextMenuItems: {
    component: defineAsyncComponent(() => import('./FilesFeatureContextMenuItems.vue'))
  }
}

export default featureConfig
